/** A list of different drink types */
export enum DrinkTypes {
  BEER = 'Beer',
  WINE = 'Wine',
  SPIRITS = 'Spirits',
  OTHER = 'Other'
}
